import React from 'react';

//TODO: load url from env:
const IPFSLink = ({ hash }) => (
  <div>
    <a href={`http://localhost:5002/ipfs/${hash}`} target="_blank">{hash}</a>
  </div>
);

export default IPFSLink;



// WEBPACK FOOTER //
// ./src/components/IPFSLink.js